module.exports = __webpack_public_path__ + "img/init.91f34bb2.svg";